import { makeStyles } from "@material-ui/core";

const DealTransferDialogStyles = makeStyles((theme) => ({
  dealContainer: {
    "&:not(:last-child)": {
      marginBottom: 24,
      paddingBottom: 24,
      borderBottom: "1px solid #E0E0E0",
    },
  },
  backdrop: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1300,
  },
  dialog: {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
    width: "800px",
    height: "770px",
    display: "flex",
    flexDirection: "column",
    boxShadow: theme.shadows[24],

     '& p': {
      height: 'unset !important',
    },
  },
  dialogTitle: {
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  titleHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  iconWrapper: {
    padding: theme.spacing(1),
    backgroundColor: theme.palette.primary.light + "40",
    borderRadius: theme.shape.borderRadius,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontSize: "18px",
    fontWeight: 600,
    margin: 0,
    color: "#133159 !important",
  },
  transferHeader: {
    background: "linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)",
    border: `1px solid ${theme.palette.primary.light}`,
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
  },
  transferFlow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
  },
  transferDot: {
    width: 12,
    height: 12,
    borderRadius: "50%",
  },
  transferLine: {
    flex: 1,
    height: 1,
    backgroundColor: theme.palette.primary.light,
  },
  transferText: {
    textAlign: "center",
    fontSize: "13px",
    color: theme.palette.text.secondary,
  },
  transferName: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#133159 !important",
  },
  dialogContent: {
    marginTop: theme.spacing(2),
    flex: 1,
    overflow: "hidden",
  },
  selectAllRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    cursor: "pointer",
    color: "#133159 !important",
  },
  chip: {
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(2),
    fontSize: "12px",
    backgroundColor: theme.palette.background.paper,
    color: "#133159 !important",
  },
  divider: {
    height: 1,
    backgroundColor: theme.palette.divider,
    marginBottom: theme.spacing(2),
  },
  dealsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    maxHeight: "345px",
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    scrollbarColor: '#888 transparent', 
    '&::-webkit-scrollbar': {
        width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#888', 
        borderRadius: '6px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
        backgroundColor: '#555', 
    },
  },
  dealCard: {
    border: `2px solid ${theme.palette.grey[300]}`,
    borderRadius: '6px',
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      borderColor: "#445af3 !important",
    },
    "&.selected": {
      borderColor: "#445af3 !important",
      // backgroundColor: theme.palette.primary.light + "20",
      backgroundColor: "#445af3" + "10",
    },
  },
  dealContent: {
    padding: theme.spacing(2),
  },
  dealHeader: {
    display: "flex",
    alignItems: "flex-start",
    gap: theme.spacing(2),
  },
  dealInfo: {
    flex: 1,
  },
  dealTitleRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: theme.spacing(2),
  },
  dealTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#133159 !important",
  },
  dealMeta: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
  },
  stageChip: {
    padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
    borderRadius: theme.spacing(2),
    fontSize: "0.75rem",
    border: "1px solid",
  },
  pipelineInfo: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    color: theme.palette.text.secondary,
    fontSize: "0.875rem",
  },
  metricsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: theme.spacing(2),
  },
  metricBox: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    border: "1px solid",
  },
  metricIcon: {
    padding: theme.spacing(1),
    borderRadius: theme.shape.borderRadius,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  metricLabel: {
    fontSize: "0.75rem",
    fontWeight: "bold",
    margin: 0,
  },
  metricValue: {
    fontSize: "0.875rem",
    fontWeight: "bold",
    margin: 0,
  },
  dialogActions: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  selectedInfo: {
    height: "35px !important",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: '7px 16px',
    backgroundColor: theme.palette.success.light + "40",
    borderRadius: '6px',
    border: `1px solid ${theme.palette.success.light}`,

  },
  selectedText: {
    fontSize: "15px",
    color: theme.palette.success.dark,
    fontWeight: 600,
    margin: 0,
  },
  buttonGroup: {
    display: "flex",
    gap: theme.spacing(2),
  },
  button: {
    padding: '8px 16px',
    borderRadius: '6px',
    border: "none",
    cursor: "pointer",
    fontSize: "15px",
    fontWeight: 600,
    transition: "all 0.2s ease-in-out",
  //    "&:disabled": {
  //   backgroundColor: "rgba(0, 0, 0, 0.12) !important",
  //   color: "rgba(0, 0, 0, 0.26) !important",
  //   border: "none !important",
  //   cursor: "not-allowed !important",
  // },
  },
  buttonOutlined: {
    backgroundColor: "transparent !important",
    border: "1px solid #445af3 !important",
    color: "#445af3 !important",
    "&:hover": {
      backgroundColor: "transparent !important",
      color: "#445af3 !important",
    },
  },
  buttonContained: {
    backgroundColor: "#445af3 !important",
    color: "white !important",
    "&:disabled": {
    backgroundColor: "rgba(0, 0, 0, 0.12) !important",
    color: "rgba(0, 0, 0, 0.26) !important",
    border: "none !important",
    cursor: "not-allowed !important",
  },

  "&:not(:disabled):hover": {
    color: "white !important",
    backgroundColor: "#445af3 !important",
  },
  },
  disabledButton: {
    color: "rgba(0, 0, 0, 0.26) !important",
    backgroundColor: "rgba(0, 0, 0, 0.12) !important",
    border: "none !important",
    cursor: "not-allowed !important",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.12) !important",
      color: "rgba(0, 0, 0, 0.26) !important",
    },
     "&:focus": {
      backgroundColor: "rgba(0, 0, 0, 0.12) !important",
      color: "rgba(0, 0, 0, 0.26) !important",
  }}
}));

export default DealTransferDialogStyles;